import React, {useContext} from 'react';
import Link from 'next/link';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import TNHContext from '@contexts/TNHContext';
import {useBooking} from '@contexts/BookingContext';

export default function SlideSpecialtyDetails({department}) {
    const {hotline} = useContext(TNHContext);
    const {setBookingInfo} = useBooking();
    const {locale} = useRouter();

    const handleCall = () => {
        if (hotline) {
            window.location.href = `tel:${hotline}`;
        }
    };

    const handleBooking = () => {
        // Set dữ liệu đặt lịch cho chuyên khoa
        setBookingInfo({
            department: department?.department_name || '',
        });

        // Scroll xuống form đặt lịch
        const formSection = document.querySelector('.register-section');
        if (formSection) {
            const offset = 150; // Khoảng cách từ top
            const elementPosition = formSection.offsetTop;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'instant',
            });
        }
    };

    return (
        <section className="hospital-system">
            <div>
                <img
                    className="hospital-system__bg"
                    src="/bw_image/medial-facility.png"
                    alt={getLocaleContent(locale, 'page.specialty-page.breadcrumb-title')}
                />
                <div className="hospital-system__actions">
                    <div className="hospital-system__card" onClick={handleCall} style={{cursor: 'pointer'}}>
                        <div className="hospital-system icon card--red">
                            <img
                                src="/bw_image/call.svg"
                                alt={getLocaleContent(locale, 'page.specialty-page.call-hotline')}
                                className="icon"
                            />
                        </div>
                        <span className="hospital-system text--red">
                            {getLocaleContent(locale, 'page.specialty-page.call-hotline')}
                        </span>
                    </div>
                    <div className="hospital-system-actions__sparate"></div>
                    <Link href="/chuyen-gia-bac-si">
                        <div className="hospital-system__card" style={{cursor: 'pointer'}}>
                            <div className="hospital-system icon card--yellow">
                                <img
                                    src="/bw_image/doctor.svg"
                                    alt={getLocaleContent(locale, 'page.specialty-page.find-doctor')}
                                    className="icon"
                                />
                            </div>
                            <span className="hospital-system text--yellow">
                                {getLocaleContent(locale, 'page.specialty-page.find-doctor')}
                            </span>
                        </div>
                    </Link>
                    <div className="hospital-system-actions__sparate"></div>
                    <div className="hospital-system__card" onClick={handleBooking} style={{cursor: 'pointer'}}>
                        <div className="hospital-system icon card--green">
                            <img
                                src="/bw_image/calendar.svg"
                                alt={getLocaleContent(locale, 'page.specialty-page.book-appointment')}
                                className="icon"
                            />
                        </div>
                        <span className="hospital-system text--green">
                            {getLocaleContent(locale, 'page.specialty-page.book-appointment')}
                        </span>
                    </div>
                </div>
            </div>
            <div className="hospital-system__title">
                <h1>
                    {department?.department_name.toUpperCase() ||
                        getLocaleContent(locale, 'page.specialty-page.default-title')}
                </h1>
            </div>
        </section>
    );
}
